import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import {
  AddOnType,
  ExtendedWarrantyTableI,
  IItemToRequest,
  MyPurchaseForm,
} from 'src/app/shared/models/app-models';
import { IAddItem } from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import { AddOn } from 'src/app/shared/models/database-models';

@Component({
  selector: 'app-extended-warranty',
  templateUrl: './extended-warranty.component.html',
  styleUrls: ['./extended-warranty.component.scss'],
})
export class ExtendedWarrantyComponent implements OnInit, OnDestroy {
  @Input() prevTab: Function = () => { };
  @Input() isReadOnly: boolean = false;
  store$: Observable<MyPurchaseForm>;
  destory$: Subject<boolean> = new Subject<boolean>();
  itemList: IItemToRequest[] = [];
  columnsToDisplay = [
    'index',
    'Description',
    'Quantity',
    'DurationYears',
    'DurationMonths',
  ];
  pageSizeOptions: number[] = [5, 10, 20];
  tableData: ExtendedWarrantyTableI[] = [];
  dataSource = new MatTableDataSource<ExtendedWarrantyTableI>(this.tableData);

  constructor(
    private store: Store<{
      form: MyPurchaseForm;
    }>,
    private router: Router
  ) {
    this.store$ = this.store.select('form');
  }

  async ngOnInit(): Promise<void> {
    this.store$
      .pipe(takeUntil(this.destory$))
      .subscribe((form: MyPurchaseForm) => {
        this.itemList = form.ItemList || [];
        this.customDataAddOn(this.itemList);
      });
  }

  customDataAddOn(itemList: IItemToRequest[]) {
    const addOnList: AddOn[] = [];
    const addItemList: IAddItem[] = [];

    itemList.forEach((item, index) => {
      if (item.AddItems) {
        addItemList.push(item.AddItems);
      }
      if (item.AddOnFeature) {
        const AddOnFeatureFilter = item.AddOnFeature.filter(
          (item) => item.AddOnTypeId == AddOnType.ExtendedWarranty
        ).map(i => ({ ...i, index: index + 1 }));
        console.log(AddOnFeatureFilter)
        addOnList.push(...AddOnFeatureFilter);
      }
    });
    const newAddOnList: AddOn[] = addOnList.map(
      (addOnItem: AddOn) => {
        const foundItem = addItemList.find((item: IAddItem) => {
          if (item.PurchaseItemId && addOnItem.PurchaseItemId) {
            return item.PurchaseItemId === addOnItem.PurchaseItemId;
          } else {
            return item.itemId === addOnItem.itemId;
          }
        });
        return {
          ...addOnItem,
          Description: foundItem?.ItemDescription,
          itemId: foundItem?.itemId,
          displayItemNumber: foundItem?.displayItemNumber,
          index: addOnItem.index,
          DurationMonths: addOnItem.DurationMonths || 0
        };
      }
    );
    this.dataSource.data = newAddOnList;
  }

  navigateToItemVendor() {
    this.prevTab();
  }

  navigateToAddItem(row: AddOn) {
    this.router.navigate([this.router.url.split(';')[0], 'edit', row.itemId], {
      queryParams: { tab: 3 },
    });
  }

  ngOnDestroy(): void {
    this.destory$.next(true);
    this.destory$.unsubscribe();
  }
}
